import { useTranslation } from 'react-i18next'

import Avatar from '../../../../../../ui/Avatar'

import { displayName } from '../../../../../../../utils/profile/profile'

type ProfilePhotoPreviewProps = {
  image: string | null
  firstName?: string
  lastName?: string
  fallbackName: string
}

const ProfilePhotoPreview = ({
  image,
  firstName,
  lastName,
  fallbackName,
}: ProfilePhotoPreviewProps) => {
  const { t } = useTranslation('account')
  const fullName = displayName(firstName, lastName, fallbackName)

  return (
    <label className="profile-photo-preview">
      {image ? (
        <img src={image} alt={t('account.profile.photo.title')} className="profile-photo-image" />
      ) : (
        <Avatar name={fullName} />
      )}
    </label>
  )
}

export default ProfilePhotoPreview
